import { PageableResponse, RestClient } from "..";

export type B040040FindRequest = Partial<{
  hachuYmdFrom: string;
  hachuYmdTo: string;
  nyukayoteiYmdFrom: string;
  nyukayoteiYmdTo: string;
  eigyoCdFrom: string;
  eigyoCdTo: string;
  bumonCdFrom: string;
  bumonCdTo: string;
  shainCdFrom: string;
  shainCdTo: string;
  hachudenpyoNoFrom: string;
  hachudenpyoNoTo: string;
  shireCd: string;
  shodaibun: string;
  shochubun: string;
  shoshobun: string;
  shohinCd: string;
  kanryoKbn: string;
  janCd: string;
  page: number;
  sort: string[];
  size: number;
}>;

export type B040040FindResponse = {
  kanryoKbn: string;
  kanryoKbnView: string;
  uchiwakeNmr: string;
  hachuYmd: string;
  nyukayoteiYmd: string;
  hachudenpyoNo: string;
  hachudenpyoNoF: string;
  shohinCd: string;
  shohinNm: string;
  hachusu: string;
  shiresu: string;
  hachuzansu: string;
  hachuKin: string;
  hachuzanKin: string;
  shireNm: string;
  shainNm: string;
  bumonNmr: string;
  version: string;
  meiVersion: string;
};

// 検索メソッド
export const B040040Find = (props: B040040FindRequest) => {
  return RestClient.get<PageableResponse<B040040FindResponse>>("b040040/find", {
    params: props,
  });
};

export type B040040UpdateField = Partial<{
  kanryoKbn: string;
  hachudenpyoNo: string;
  hachugyoNo: string;
  version: string;
  meiVersion: string;
}>;

export type B040040UpdateRequest = {
  hachumeiList: B040040UpdateField[];
};

// 入力更新メソッド
export const B040040Update = (props: B040040UpdateRequest) => {
  return RestClient.put("b040040/update", props);
};
